import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "initials"
}
const _hoisted_4 = { "data-cy": "selected-user-name-txt" }

import store from "@/store";
import endpoints from "@services/endpoints";
import { getInitials } from "@util/user";
import { computed } from "vue";
import { useState } from "vuex-composition-helpers";
import { RootState } from "@medapro-types/common/rootstate";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileSelectorItem',
  props: {
    id: {},
    username: {},
    department: {},
    hasImage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { auth } = useState<RootState>(["auth"]);



const profileImage = computed(() => {
  if (!props.id) {
    return "";
  }
  return store.state.meta.config.apiUrl + endpoints.user.profile.getProfileImage + `?raw=true&userId=${props.id}&key=${auth.value.token}`;
});

const username = computed(() => {
  return props.department ? `${props.username} (${props.department})` : props.username;
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, [
      (props.hasImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: profileImage.value,
            loading: "lazy"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(getInitials)(props.username)), 1))
    ]),
    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
      _createTextVNode(_toDisplayString(username.value), 1)
    ])), [
      [
        _directive_tooltip,
        username.value,
        void 0,
        {
          ellipsis: true,
          mouse: true
        }
      ]
    ])
  ], 64))
}
}

})